import classNames from './PopUpOpenWrittingSuccess.module.scss';
import SVG from 'react-inlinesvg';
import { useTranslation } from 'react-i18next';
import success from '@/assets/svg/check.svg';

const PopUpOpenWrittingSuccess = () => {
  const { t } = useTranslation();

  return (
    <div className={classNames.popUpOpenWrittingSuccess}>
      <div className={classNames.title}>
        <SVG src={success} />
        <p>{t('thanksForSubmission')}</p>
      </div>
    </div>
  );
};

export default PopUpOpenWrittingSuccess;
